import {SearchTab} from "./fetch_search_all_action";

export interface IUpdateCurrentTabAction {
    type: string;
    currentTab: SearchTab;
}

export const UPDATE_CURRENT_TAB = "search_engine/UPDATE_CURRENT_TAB";
export const updateCurrentTab = (currentTab: SearchTab) => ({type: UPDATE_CURRENT_TAB, currentTab});
